import { FixedPageHeader } from 'Components/Layout';
import { useSelector } from 'react-redux';

interface IAdminPageHeaderProps {
  pageIdentifier: string;
}

const AdminPageHeader: React.FC<IAdminPageHeaderProps> = ({ pageIdentifier }) => {
  const syncing = useSelector((state) => state.admin.status?.syncing);
  const dirty = useSelector((state) => state.admin.status?.dirty);

  return (
    <FixedPageHeader
      pageIdentifier={pageIdentifier}
      pageStatus={syncing ? 'Saving...' : 'Saved'}
      pageProcessing={syncing || dirty}
    />
  );
};

export default AdminPageHeader;
